<template>
  <button
    class="button"
    :class="{ 'is-loading': loading_state, 'is-grayed-out': disabled_state }"
    @click="submit()"
    :disabled="disabled_state || loading_state"
    v-translate>
    <slot></slot>
  </button>
</template>
<script>
  export default {
    name: 'submit-btn-component',
    data () {
      return {
        disabled_state: false,
        loading_state: false
      }
    },
    props: {
      group: {
        type: String,
        default: null
      }
    },
    methods: {
      submit () {
        this.disable()
        this.$emit('submit', this)
      },
      enable () {
        this.loading_state = false
        this.updateGroupButtons(false)
      },
      disable () {
        this.loading_state = true
        this.updateGroupButtons(true)
      },
      updateGroupButtons (state) {
        for (let btn of this.getGroupButtons()) {
          btn.disabled_state = state
        }
      },
      getGroupButtons () {
        return this.group ? this.$parent.$children.filter(child => {
          return child.group === this.group && child !== this
        }) : []
      }
    }
  }
</script>

<style lang="sass">
</style>
